import { render, staticRenderFns } from "./faqdetails.vue?vue&type=template&id=3f30ad1a&scoped=true"
import script from "./faqdetails.vue?vue&type=script&lang=js"
export * from "./faqdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f30ad1a",
  null
  
)

export default component.exports